import { Box, Typography } from "@outschool/backpack";
import { faTimes } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { IconButton } from "@outschool/ui-legacy-component-library";
import React from "react";

import { TeacherPublicProfileQueryQuery } from "../../../../../shared/generated/graphql";
import PageModal from "../../../PageModal";
import { MessageModalContainer } from "./MessageModalContainer";
import { UpcomingClassesInfiniteScroll } from "./UpcomingClassesInfiniteScroll";

type UpcomingClassesModalProps = {
  isModalOpen: boolean;
  handleCloseModal: () => void;
  // @ts-ignore TS(2339): Property 'leader' does not exist on type '{ __type... Remove this comment to see the full error message
  leader: TeacherPublicProfileQueryQuery["publicProfile"]["leader"];
};

export const UpcomingClassesModal: React.FunctionComponent<
  UpcomingClassesModalProps
> = ({ isModalOpen, handleCloseModal, leader }) => {
  const { t } = useTranslation(
    "client\\components\\teacher\\TeacherProfile\\UpcomingClassesModal",
  );
  return (
    <PageModal
      open={isModalOpen}
      onClose={handleCloseModal}
      sx={{
        height: "90vh",
        position: "relative",
        padding: "0px",
      }}
      hasCloseButton={false}
    >
      <Box
        sx={{
          height: "100%",
          paddingX: "24px",
          paddingBottom: "0px",
          overflowY: "auto",
          paddingTop: "70px",
          scrollbarWidth: "none",
          "::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        <UpcomingClassesModalHeader handleCloseModal={handleCloseModal} />

        <Typography
          variant="inherit"
          sx={{
            display: "block",
            fontSize: "14px",
            color: "grey.500",
            lineHeight: "20px",
            paddingBottom: "10px",
          }}
        >
          {t("Contact {{leaderName}} for dates and times not listed", {
            leaderName: leader.name,
          })}
        </Typography>

        <MessageModalContainer leader={leader} />

        <Box
          sx={{
            paddingTop: "20px",
            marginX: "-24px",
            borderBottom: "1px solid #DDDFE3",
          }}
        />

        <UpcomingClassesInfiniteScroll leaderUid={leader.uid} />
      </Box>
    </PageModal>
  );
};

type UpcomingClassesModalHeaderProps = {
  handleCloseModal: UpcomingClassesModalProps["handleCloseModal"];
};

const UpcomingClassesModalHeader: React.FunctionComponent<
  UpcomingClassesModalHeaderProps
> = ({ handleCloseModal }) => {
  const { t } = useTranslation(
    "client\\components\\teacher\\TeacherProfile\\UpcomingClassesModal",
  );
  return (
    <Box
      sx={{
        background: "white",
        paddingBottom: "20px",
        borderRadius: "0.5em",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        paddingX: "24px",
        paddingTop: "24px",
        zIndex: 2001,
      }}
    >
      <Typography variant="h3">{t("Upcoming Classes")}</Typography>

      <Box
        sx={{
          position: "absolute",
          top: "0.5em",
          right: "0.5em",
          zIndex: 1,
        }}
      >
        <IconButton
          icon={faTimes}
          iconProps={{ sx: { fontSize: "1.333em" } }}
          onClick={handleCloseModal}
          aria-label={t("Close")}
        />
      </Box>
    </Box>
  );
};
